import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AppAdminTableViewComponent } from '../../app-admin-table-view/app-admin-table-view.component';
import { ViewModeToggleComponent } from '../../shared/components/view-mode-toggle/view-mode-toggle.component';
import { LoaderComponent } from '../../shared/loader/loader.component';
import { NoDataFoundComponent } from '../../shared/no-data-found/no-data-found.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OrgsRegistrationComponent } from '../orgs-registration/orgs-registration.component';
import { MemberInsurerServiceService } from '@app/modules/lps-member-login/services/member-insurer-service.service';
import { MemberInsurerRestService } from '@app/modules/lps-member-login/services/member-insurer-rest.service';
import { NotificationService } from '../../shared/services/notifications.service';
import { AdminCardComponent } from "../../admin-card/admin-card.component";
import { ConfirmationmodalComponent } from '../../shared/components/confirmationmodal/confirmationmodal.component';

@Component({
  selector: 'app-orgs-view',
  standalone: true,
  imports: [MatInputModule, MatFormFieldModule, FormsModule, CommonModule, LoaderComponent, NoDataFoundComponent, ViewModeToggleComponent, AppAdminTableViewComponent, AdminCardComponent],
  templateUrl: './orgs-view.component.html',
  styleUrl: './orgs-view.component.scss'
})
export class OrgsViewComponent {
openAdminProfile($event: any) {
throw new Error('Method not implemented.');
}


 statusupdateTrue(adminInfo: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '350px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    this.notificationService.showNotification(adminInfo.userId)

    const dialogRef = this.dialog.open(ConfirmationmodalComponent, dialogConfig);
    dialogRef.componentInstance.title = 'Confirm';
    dialogRef.componentInstance.mode = 'Add';
    dialogRef.componentInstance.message = 'Are you sure you want to update the status?';

    dialogRef.afterClosed().subscribe((isConfirmed: boolean) => {
      if (isConfirmed) {
        this.restService.updateOrganisationStatus(adminInfo.orgId, true).subscribe({
          next: (response: string) => {
            this.notificationService.showNotification('Status updated sucessfully');
            if (this.selectedTab === 0)
              this.memberService.emitRefreshAdminInsurer();
            else if (this.selectedTab === 1) {
              this.memberService.emitRefreshAdminProvider();
            }
            else {
              this.memberService.emitRefreshAdminDistributor();
            }
          },
          error: (error) => {
            const message = error?.error?.message || 'An error occurred during status update.';
            this.notificationService.showNotification(message, 'error');
          }
        });
      }
    })
  }


 statusupdateFalse(adminInfo: any) {
    // console.log(this.role)

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '350px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;

    const dialogRef = this.dialog.open(ConfirmationmodalComponent, dialogConfig);
    dialogRef.componentInstance.title = 'Confirm';
    dialogRef.componentInstance.mode = 'Add';
    dialogRef.componentInstance.message = 'Are you sure you want to update the status?';

    dialogRef.afterClosed().subscribe((isConfirmed: boolean) => {
      if (isConfirmed) {
        this.restService.updateOrganisationStatus(adminInfo.orgId, false).subscribe({
          next: (response: string) => {
            this.notificationService.showNotification('Status updated sucessfully');
            if (this.selectedTab === 0)
              this.memberService.emitRefreshAdminInsurer();
            else if (this.selectedTab === 1) {
              this.memberService.emitRefreshAdminProvider();
            }
            else {
              this.memberService.emitRefreshAdminDistributor();
            }
          },
          error: (error) => {
            const message = error?.error?.message || 'An error occurred during status update.';
            this.notificationService.showNotification(message, 'error');
          }
        });
      }
    })

  }

openAdminInsurerForm(row: any) {
const rows = row;
    console.log(row);
    const adminInsurerDialogConfig = new MatDialogConfig();
    adminInsurerDialogConfig.data = row;
    adminInsurerDialogConfig.width = '750px';
    adminInsurerDialogConfig.height = '600px'
    const adminInsurerReference = this.dialog.open(OrgsRegistrationComponent, adminInsurerDialogConfig)
}

  isSidebarExpanded = false;
  currentPage = 1;
  itemsPerPage = 6;
  totalPages = 1;
  isRotating: boolean = false;
  selectedFilter: 'all' | 'active' | 'inactive' = 'all';
  viewMode: 'grid' | 'list' = 'grid';
  searchExpanded = false;
  searchQuery: string = '';
  providerorg: any[] = [];
  paginatedorganisations:any[]=[];
  providerorgtemp:any[]=[]
    insurerorg:any[]=[];
    insurerorgtemp:any[]=[];
    
    distributororg:any[]=[];
        distributororgtemp:any[]=[]

  DisplayedColums:string[]=['Name','Activation Term','Phone','Email','Address','Status','Actions']

  constructor(private dialog: MatDialog,private memberService : MemberInsurerServiceService ,private restService: MemberInsurerRestService,private notificationService: NotificationService) {
    
  }
  

  ngOnInit(): void {
    this.memberService.sidebarExpanded$.subscribe((expanded) => {
      if (expanded) {
        this.isSidebarExpanded = false;
      } else {
        this.isSidebarExpanded = true;
      }
    });
    this.getAllOrgs();

         this.getInsurerOrg() ;
         this.getproviderOrg();
         this.getDistributorOrg()

         this.memberService.refreshInsurerOrg$.subscribe(()=>{
          this.getInsurerOrg();
          this.selectedTab=0;
         })
          this.memberService.refreshProviderOrg$.subscribe(()=>{
          this.getproviderOrg();
          this.selectedTab=1;
         })
          this.memberService.refreshDistributorOrg$.subscribe(()=>{
          this.getDistributorOrg();
          this.selectedTab=2;
         })

  }

  changeViewMode(mode: 'list' | 'grid') {
    this.viewMode = mode;
  }

  applyFilter(filterType: 'all' | 'active' | 'inactive'): void {
    if(this.selectedTab===0){
      if(filterType==='active'){
      this.insurerorg=this.insurerorgtemp.filter((org)=>org.isactive===true);
       this.calculateTotalPages(this.insurerorg);
      this.updateVisibleItems(this.insurerorg);
    
    }
     
      else if(filterType==='inactive'){
        
        this.insurerorg=this.insurerorgtemp.filter((org)=>org.isactive===false);
        this.calculateTotalPages(this.insurerorg);
      this.updateVisibleItems(this.insurerorg);
      }
      else if(filterType==='all'){
        this.insurerorg=[...this.insurerorgtemp];
        this.calculateTotalPages(this.insurerorg);
      this.updateVisibleItems(this.insurerorg);


      }
    }
    //providerOrgfilterationandpagination

    else if(this.selectedTab===1){
      if(filterType==='active'){
      this.providerorg=this.providerorgtemp.filter((org)=>org.isactive===true);
       this.calculateTotalPages(this.providerorg);
      this.updateVisibleItems(this.providerorg);
    
    }
     
      else if(filterType==='inactive'){
        
        this.providerorg=this.providerorgtemp.filter((org)=>org.isactive===false);
        this.calculateTotalPages(this.providerorg);
      this.updateVisibleItems(this.providerorg);
      }
      else if(filterType==='all'){
        this.providerorg=[...this.providerorgtemp];
        this.calculateTotalPages(this.providerorg);
      this.updateVisibleItems(this.providerorg);


      }
    }
    //distributororgfilterationanfpagination

    else if(this.selectedTab===2){
      if(filterType==='active'){
      this.distributororg=this.distributororgtemp.filter((org)=>org.isactive===true);
       this.calculateTotalPages(this.distributororg);
      this.updateVisibleItems(this.distributororg);
    
    }
     
      else if(filterType==='inactive'){
        
        this.distributororg=this.distributororgtemp.filter((org)=>org.isactive===false);
        this.calculateTotalPages(this.distributororg);
      this.updateVisibleItems(this.distributororg);
      }
      else if(filterType==='all'){
        this.distributororg=[...this.distributororgtemp];
        this.calculateTotalPages(this.distributororg);
      this.updateVisibleItems(this.distributororg);


      }
    }

    this.currentPage = 1;

  }


  

  onRefresh() {
    this.isRotating = true;
    this.getAllOrgs();
    // Stop animation after 1s (match CSS animation duration)
    setTimeout(() => {
      this.isRotating = false;
    }, 500);
  }

  getAllOrgs() {

  }

  openAdminInsurer() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '750px';
    dialogConfig.height = '600px';
    this.dialog.open(OrgsRegistrationComponent, dialogConfig);
  }

  toggleSearch() {
    this.searchExpanded = !this.searchExpanded;
    if (!this.searchExpanded) {
      this.searchQuery = '';
      this.onSearch(); // reset search on close
    }
  }

  tabs = [
    { label: 'Insurer Organisation', count: 0 },
    { label: 'Provider Organisation', count: 0 },
    { label: 'Distributor Organisation', count: 0 }
  ];
 selectedTab = 0;
  handleTabClick(index: number): void {
    this.selectedTab = index;
    this.currentPage = 1;
    this.searchQuery = ''; // Reset search when switching tabs
    this.onTabClick();
  }

  
  onTabClick(): void {
    if (this.selectedTab === 0) {
     this.getInsurerOrg() ;
    }
    else if (this.selectedTab === 1) {
      this.getproviderOrg();
    }
    else if(this.selectedTab===2) {
      this.getDistributorOrg();
    }
    // Don't call applyFilter here as it will be called in the data loading methods
  }

  getproviderOrg() {
    this.providerorg = [];
    this.restService.getAllProviderOrganisations().subscribe({
      next: (values) => {
        this.providerorgtemp = values;
        console.log(values)
        this.tabs[1].count=values?.length;
        this.calculateTotalPages(this.providerorgtemp)
        this.updateVisibleItems(this.providerorgtemp)
      },
      error: (err) => {
        console.log(err);
        this.notificationService.showNotification(err);
      }
    })
  }

  isDataLoading: boolean = false;

   prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      // this.updateVisibleItems();
    }
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      if(this.selectedTab===0){
              this.updateVisibleItems(this.insurerorgtemp); }
      else if(this.selectedTab===1){
                      this.updateVisibleItems(this.providerorgtemp);
 }
      else if(this.selectedTab===2){
                              this.updateVisibleItems(this.distributororgtemp)
      }
    }
  }

   nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
       this.updateVisibleItems(this.paginatedorganisations);
    }
  }
 calculateTotalPages(list: any[]): void {
    this.totalPages = Math.ceil(list.length / this.itemsPerPage);
    console.log(this.totalPages)
  }
   updateVisibleItems(list:any[]): any[]{
  
    const start = (this.currentPage - 1) * this.itemsPerPage;
    console.log(start)
    const end = start + this.itemsPerPage;
    console.log(end)
    // console.log(this.agentsList)
    // this.currentPage++;

    if (this.selectedTab === 0) {
      return this.insurerorg= list.slice(start, end);
      
    
    } else if (this.selectedTab === 1) {
     return this.providerorg =list.slice(start, end);
    
    }
    else if (this.selectedTab === 2) {
      return this.distributororg = list.slice(start, end);
      
    }
    console.log("the paginated org")
        console.log(this.paginatedorganisations)

    return [];
  }


   getInsurerOrg() {
    this.insurerorg = [];
    this.isDataLoading=true;
    this.restService.getAllInsurerOrganisations().subscribe({
      next: (values) => {
        this.insurerorg = values;
        console.log(values)
        this.isDataLoading=false;
        this.tabs[0].count=values?.length;

         if (values.length > 0) {
          const sorted = values
            .filter((agent: { createdon: any; }) => agent.createdon)
            .sort((a: { createdon: string | number | Date; }, b: { createdon: string | number | Date; }) => new Date(b.createdon).getTime() - new Date(a.createdon).getTime()
             
            );

          this.insurerorgtemp = sorted;
          this.tabs[0].count = this.insurerorgtemp.length;
          this.isDataLoading = false;
           this.calculateTotalPages(this.insurerorgtemp);
          this.updateVisibleItems(this.insurerorgtemp);

          // Apply current filter and update pagination
          this.applyFilter(this.selectedFilter);
        } else {
          this.isDataLoading = false;
          this.insurerorgtemp = [];
          this.tabs[0].count = 0;
         
        }
      },
      error: (err) => {
        console.log(err);
        this.notificationService.showNotification(err);
        this.isDataLoading=false
      }
    })
  }


  getDistributorOrg(){

     this.distributororg = [];
    this.restService.getAllDistributorOrganisations().subscribe({
      next: (values) => {
        this.distributororgtemp = values;
        console.log(values)
        this.tabs[2].count=values?.length;
        this.calculateTotalPages(this.distributororgtemp);
        this.updateVisibleItems(this.distributororgtemp)
      },
      error: (err) => {
        console.log(err);
        this.notificationService.showNotification(err);
      }
    })
  }

  onSearch() {
    // Reset to page 1 when searching
    this.currentPage = 1;
  }

}
